module.exports = __webpack_public_path__ + "assets/icons/new-jobs.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/new-jobs.png
// module id = ./src/styles/icons/sidemenu/new-jobs.png
// module chunks = 0